import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[capitalize]'
})
export class CapitalizeDirective  {

  constructor(private control: NgControl) { }

  @HostListener('blur')
  onBlur(): void {
    const formatted: string = this.format(this.control.value);
    this.control.control.setValue(formatted, {emitEvent: false});
  }

  private format(value: string): string {
    if (!value) {
      return null;
    }

    if (typeof value !== 'string') {
      value = (value as any).toString();
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
